import { IconButton, VStack } from '@genial/components';
import React from 'react';

import { MultipleAccountsSelection } from '../../../../components/MultipleAccountsSelection';
import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../components/TableContent';
import { customersTableHead } from '../../constants';

import { CustomerAccountStatus } from './shared/CustomerAccountStatus';
import { CustomerBalance } from './shared/CustomerBalance';
import { CustomerName } from './shared/CustomerName';
import { IncomeTaxButton } from './shared/IncomeTaxButton';

import { CustomerTableItemTypes } from '.';

export const CustomerTableItemDesktop: React.FC<CustomerTableItemTypes.Props> = ({
  customer,
  customerDetailHref,
  customerDetailNavigation,
  onDownloadIncomeStatementFile,
  isExporting,
  accountSelected,
  setAccountSelected,
}) => {
  const getFlex = (index: number) => {
    const currentHead = customersTableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent direction="row" space={0} p={0} px="inline.xxxs" h="80px">
      <TableContentItemColumn flex={getFlex(0)}>
        <CustomerName customer={customer} />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <VStack space="stack.quarck">
          <TableContentItemText color="neutral.darkest">
            {customer.cpfCnpjNormalized}
          </TableContentItemText>
          <TableContentItemText color="neutral.medium" fontSize="xs">
            {customer.personTypeNormalized}
          </TableContentItemText>
        </VStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <MultipleAccountsSelection
          accounts={customer.accountsNormalized}
          accountSelected={accountSelected}
          setAccountSelected={setAccountSelected}
        />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <CustomerBalance accountSelected={accountSelected} />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <IncomeTaxButton
          customer={customer}
          isExporting={isExporting}
          onDownloadIncomeStatementFile={onDownloadIncomeStatementFile}
        />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <VStack space="stack.quarck">
          <CustomerAccountStatus customer={customer} />
          <TableContentItemText color="neutral.medium" fontSize="xs">
            {customer.accountDateNormalized}
          </TableContentItemText>
        </VStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <IconButton
          onPress={customerDetailNavigation}
          testId="customers-table-item-desktop-action"
          icon="ChevronRight"
          iconSize="xxs"
          iconColor="brand.tertiary.principal"
          href={customerDetailHref}
        />
      </TableContentItemColumn>
    </TableContent>
  );
};
